var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcNoteRibbon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "58px",
    viewBox: "0 0 38 58",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icNoteRibbon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.51718654e-13,-1.70530257e-13 L5.22673963e-05,54.1123721 C-0.00445881138,54.6123121 0.283371033,55.0675525 0.733355517,55.2721868 C1.18334,55.4768212 1.71014038,55.3920409 2.0754833,55.0561924 L18.0000523,40.7022598 L33.9246212,55.0561924 C34.2899642,55.3920409 34.8167645,55.4768212 35.266749,55.2721868 C35.7167335,55.0675525 36.0045633,54.6123121 36.0000523,54.1123721 L36.0001045,-1.70530257e-13 L34.758673,-9.90037184e-14 L1.24143158,-9.90037184e-14 L1.12505227,-9.90037184e-14 L3.51718654e-13,-1.70530257e-13 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-5.6%",
    y: "-1.8%",
    width: "111.1%",
    height: "107.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.136294158 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RHP-Search--Desktop-v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Profile-user-info",
    transform: "translate(-923.000000, -512.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icNoteRibbon",
    transform: "translate(924.000000, 512.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#7EC34D",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.4744999,23.1599684 C27.7647566,23.1599684 28,23.3958424 28,23.6868771 L28,28.3654563 C27.9983578,29.8198068 26.8229619,30.9983534 25.3724995,31 L10.6275005,31 C9.17703813,30.9983534 8.00164219,29.8198068 8,28.3654563 L8,14.6345437 C8.00164219,13.1801932 9.17703813,12.0016466 10.6275005,12 L15.2933666,12 C15.5836233,12 15.8188667,12.2360798 15.8188667,12.5269087 C15.8188667,12.8179435 15.5836233,13.0538175 15.2933666,13.0538175 L10.6275005,13.0538175 C9.75714095,13.0548466 9.05202655,13.7620569 9.05100019,14.6345437 L9.05100019,28.3652505 C9.05202655,29.2379431 9.75714095,29.9451534 10.6275005,29.9459767 L25.3724995,29.9459767 C26.2428591,29.9451534 26.9479734,29.2379431 26.9489998,28.3652505 L26.9489998,23.6868771 C26.9489998,23.3958424 27.1842432,23.1599684 27.4744999,23.1599684 Z M27.642118,10.7188807 L28.2821741,11.35888 C29.2392753,12.3180268 29.2392753,13.8707281 28.2821741,14.8298749 L18.551148,24.5604635 C18.4844577,24.6271478 18.4017873,24.6752969 18.3110204,24.7004367 L13.6910681,25.9802222 C13.5016507,26.0326323 13.2988101,25.979157 13.1596767,25.840249 C13.0207563,25.701128 12.9672763,25.4983053 13.0199041,25.3089048 L14.2995902,20.6893625 C14.3247322,20.5986036 14.3728856,20.5159406 14.4395758,20.4492562 L24.170815,10.7188807 C25.1294077,9.76037311 26.6835253,9.76037311 27.642118,10.7188807 Z M15.6280688,20.8037698 L18.1963898,23.372076 L26.1608696,15.408303 L23.5923355,12.8399969 L15.6280688,20.8037698 Z M15.1150012,21.8332228 L14.3285674,24.6716751 L17.1670586,23.8853111 L15.1150012,21.8332228 Z M27.5108681,14.0586374 C28.0424727,13.5258017 28.0424727,12.6631662 27.5108681,12.1301175 L26.870599,11.4901182 C26.3381422,10.9577086 25.4747908,10.9577086 24.942334,11.4901182 L24.3636415,12.0685463 L26.9323887,14.6370655 L27.5108681,14.0586374 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNoteRibbon);
export default __webpack_public_path__ + "static/media/icNoteRibbon.6bd3f1be8e6dc26d06624dc7cb6e20d0.svg";
export { ForwardRef as ReactComponent };